import { useEffect, useState } from "react";
import styled from "styled-components";
import statefulField from "./StatefulField";
import EyeHide from "../images/eye-hide.svg"
import EyeShow from "../images/eye-show.svg"

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;

  .form-label {
    font-size: 0.8rem;
  }
`;

const SwitchWrapper = styled.div(({ theme, status, labels }) => `
    color: #fff;
    font-size: 0.8125rem;
    font-family: Helvetica, Verdana, Arial, sans-serif;
    height: 32px;
    width: 60px;
    border-radius: 25px;

    .inset {
        background-color: ${status ? "#21DE93" : "#CE3031"};
    }

    .inset .control {
        float: ${(status ? "right" : "left")};
        ${status ? `right: 4px;`: `left: 4px;`}
    }

    ${status
        ? `
        .inset .control:before {
            content: ${labels.on.toLowerCase() === 'show' ? `url(${EyeShow});` : `"${labels.on}";`}
            position: relative;
            left: -100%;
            top: 50%;
            transform: translate3d(0, -50%, 0);
            white-space: nowrap;
            overflow: hidden;
            display: block;
            text-overflow: ellipsis;
            width: ${labels.on.toLowerCase() === 'show' ? `16px;` : `auto;`}
            height: ${labels.on.toLowerCase() === 'show' ? `16px;` : `auto;`}
        }
        `
        : `
        .inset .control:after {
            content: ${labels.off.toLowerCase() === 'hide' ? `url(${EyeHide});` : `"${labels.off}";`}
            position: relative;
            right: -120%;
            top: 50%;
            transform: translate3d(0, -50%, 0);
            white-space: nowrap;
            overflow: hidden;
            display: block;
            text-overflow: ellipsis;
            width: ${labels.off.toLowerCase() === 'hide' ? `16px;` : `auto;`}
            height: ${labels.off.toLowerCase() === 'hide' ? `16px;` : `auto;`}
        }
        `}

    .inset {
        width: 100%;
        height: 100%;
        border-radius: 20px;
    }

    .inset .control {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        background-color: #F8F9FF;
        top: 50%;
        position: relative;
        transform: translate3d(0, -50%, 0);
    }

    .inset .control:hover {
        cursor: pointer;
    }

    &.disabled {
        color: #ccc;
    }

    &.disabled .inset {
        background-color: #ADADAD;
    }

    &.disabled .control {
        cursor: default;
    }

    &:focus {
        outline: 2px solid ${theme.accent2Color};
    }
`);

export const Switch = ({
  label,
  labels,
  on,
  off,
  value,
  setValue,
  onChange,
}) => {
  const [status, setStatus] = useState(value === on);

  useEffect(() => setStatus(value === on), [on, value]);

  const change = () => {
    if (setValue) {
      const newValue = status ? off : on
      const newStatus = !status
      setValue(newValue);
      setStatus(newStatus);
      onChange && onChange(newStatus);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key !== "Enter") return;
    change();
  };

  return (
    <SwitchContainer className="form-outline">
      <label className="form-label">{label}</label>
      <SwitchWrapper labels={labels} status={status} onClick={change} tabIndex={0} onKeyUp={handleKeyUp}>
        <div className="inset">
          <div className="control"></div>
        </div>
      </SwitchWrapper>
    </SwitchContainer>
  );
};

export default statefulField(Switch);